var exports = {
  "kL": "x52a3aa3b--1a7d2a--container",
  "AV": "x52a3aa3b--1a7d2a--desktop-only",
  "h_": "x52a3aa3b--1a7d2a--description",
  "z6": "x52a3aa3b--1a7d2a--agreement",
  "x6": "x52a3aa3b--1a7d2a--button",
  "lP": "x52a3aa3b--1a7d2a--adaptive",
};

module.exports = exports;
